import Vue from "vue";
import EndPoint from "../../formability/organization_settings/models/connections/endPoint";
import DynamicInput from "./dynamicInput";


export default class DynamicInputFactory {
  static create(parent, json = {}, trackChange = true, isUntracked = false, isResponse = false) {
    let dynamicInput = isUntracked ? new DynamicInput() : new DynamicInput() 

    if (typeof json['sort_order'] !== 'number') {
      if (parent instanceof EndPoint && isResponse) {
        json['sort_order'] = parent.nextResponseDynamicInputSortOrder;
      } else {
        json['sort_order'] = parent.nextDynamicInputSortOrder;
      }
    }

    dynamicInput.definePropertiesFrom(parent, json);
    dynamicInput.rootModel = parent.rootModel;
    dynamicInput.parent = parent;

    if (isResponse) {
      // needed for destroying of model
      dynamicInput._nameInParent = "response_dynamic_inputs"
      Vue.set(parent.response_dynamic_inputs, dynamicInput.client_id, dynamicInput);
    } else {
      Vue.set(parent.certificate_dynamic_inputs, dynamicInput.client_id, dynamicInput);
    }
    
    DynamicInput.repo.add(dynamicInput)

    return dynamicInput;
  }

  static remove(dynamicInput: DynamicInput) {
    DynamicInput.repo.remove(dynamicInput)
    Vue.delete(dynamicInput.parent[dynamicInput.rootName], dynamicInput.clientIdOrId);
    dynamicInput.destroy();
  }
}